import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FaSync, FaPencilAlt, FaEye, FaEyeSlash, FaExclamationCircle } from 'react-icons/fa';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import Spinner from '../../components/UI/Spinner/Spinner';
import Modal from '../../components/UI/Modal/Modal';
import Success from '../../components/UI/Success/Success';
import Switch from '../../components/UI/Switch/Switch';
import SelectDropdown from '../../shared/SelectDropdown/SelectDropdown';
import ResidentNetworks from '../../containers/PropertyManager/ResidentNetworks/ResidentNetworks';
import PspView from '../../containers/PropertyManager/PspView/PspView';
import * as actions from '../../store/actions/index';
import classes from './NetworksPage.css';

const CONNECTION_FILTERS = [
  { value: 'All', label: 'All' },
  { value: 'CONNECTED', label: 'CONNECTED' },
  { value: 'DISCONNECTED', label: 'DISCONNECTED' },
];

const ITEMS_PER_PAGE = 10;

const NETWORK_TYPE_LABELS = {
  ADMIN: 'ADMIN NETWORK',
  GUEST: 'GUEST NETWORK',
  STAFF: 'STAFF NETWORK',
  OFFICE: 'OFFICE NETWORK',
  IOT: 'IOT NETWORK',
};

class NetworksPage extends Component {
  state = {
    showPassword: false,
    currentPage: 1,
    connectionFilter: 'All',
    activeTab: 'Devices',
    showEditModal: false,
    showConfirmModal: false,
    editSsidName: '',
    editPassword: '',
    editBroadcast: true,
    showEditPassword: false,
    showConfirmPassword: false,
    showSsidGuidelines: false,
    showPasswordGuidelines: false,
    ssidError: '',
    passwordError: '',
    showSuccessModal: false,
    retrying: false,
    retryAttempted: false,
    deviceLoadDelay: true,
    refreshingDevices: false,
  };

  componentDidMount() {
    if (this.props.selectedNetwork) {
      this.setState({ activeTab: this.getDefaultTab(this.props.selectedNetwork.wifiType) });
      this.props.getNetworkDevices(this.props.selectedNetwork.wifiType);
    }
    this._deviceLoadTimer = setTimeout(() => {
      this.setState({ deviceLoadDelay: false });
    }, 3000);
    if (sessionStorage.getItem('networkUpdateSuccess') === 'true') {
      sessionStorage.removeItem('networkUpdateSuccess');
      this.setState({ showSuccessModal: true });
      setTimeout(() => this.setState({ showSuccessModal: false }), 3000);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedNetwork &&
      (!prevProps.selectedNetwork ||
        prevProps.selectedNetwork.wifiType !== this.props.selectedNetwork.wifiType)
    ) {
      this.setState({
        currentPage: 1,
        connectionFilter: 'All',
        showEditModal: false,
        showConfirmModal: false,
        showPassword: false,
        activeTab: this.getDefaultTab(this.props.selectedNetwork.wifiType),
        deviceLoadDelay: true,
      });
      this.props.getNetworkDevices(this.props.selectedNetwork.wifiType);
      if (this._deviceLoadTimer) clearTimeout(this._deviceLoadTimer);
      this._deviceLoadTimer = setTimeout(() => {
        this.setState({ deviceLoadDelay: false });
      }, 3000);
    }
    if (!prevProps.updateNetworkSuccess && this.props.updateNetworkSuccess) {
      this.setState({ showConfirmModal: false, showEditModal: false });
      sessionStorage.setItem('networkUpdateSuccess', 'true');
      window.location.reload();
    }
    if (!prevProps.updateNetworkError && this.props.updateNetworkError) {
      if (this.state.retryAttempted) {
        this.setState({ showConfirmModal: false, showEditModal: false, retryAttempted: false });
      } else {
        this.setState({ showConfirmModal: false, showEditModal: true });
      }
    }
  }

  componentWillUnmount() {
    if (this._deviceLoadTimer) clearTimeout(this._deviceLoadTimer);
    if (this._refreshTimer) clearTimeout(this._refreshTimer);
  }

  isCssoUser = () => {
    return (sessionStorage.getItem("userRoles") || []).includes('CSSO');
  };

  isMduNonBulk = () => {
    return this.props.isMduNonBulk || this.props.accountClassification === 'MDUNONBULK';
  };

 isMduBulk = () => {
    return this.props.isMduBulk || this.props.accountClassification === 'MDUBULK';
  };

  getDefaultTab = (wifiType) => {
    const availableTabs = this.getAvailableTabs(wifiType);
    if (availableTabs.includes('NetworkInfo')) return 'NetworkInfo';
    return 'Devices';
  };

  getAvailableTabs = (wifiType) => {
    if (this.isMduNonBulk()) return ['NetworkInfo', 'Devices'];
    if (this.isMduBulk()) {
      if (this.props.isSpectrumReady) {
        if (wifiType === 'IOT') return ['NetworkInfo', 'Devices'];
        if (wifiType === 'GUEST') return ['NetworkInfo'];
        if (['STAFF', 'OFFICE', 'ADMIN'].includes(wifiType)) return ['Devices'];
      }
      return ['NetworkInfo'];
    }
    const isCsso = this.isCssoUser();
    const isClassificationNull = !this.props.accountClassification;
    if (wifiType === 'IOT') {
      return (this.props.isSpectrumReady || isClassificationNull) ? ['NetworkInfo', 'Devices'] : ['NetworkInfo'];
    }
    if (wifiType === 'GUEST') return ['NetworkInfo'];
    if (isCsso && ['STAFF', 'OFFICE', 'ADMIN'].includes(wifiType)) return ['Devices'];
    return ['Devices'];
  };

  canEditNetwork = () => {
    // Only CSSO users can edit Wi-Fi network for all network types
    return this.isCssoUser();
  };

  isPasswordEditable = () => {
    const { selectedNetwork } = this.props;
    return selectedNetwork && selectedNetwork.wifiType !== 'GUEST';
  };

  handleRefresh = () => {
    if (this.props.selectedNetwork) {
      this.setState({ refreshingDevices: true });
      if (this._refreshTimer) clearTimeout(this._refreshTimer);
      this._refreshTimer = setTimeout(() => {
        this.props.getNetworkDevices(this.props.selectedNetwork.wifiType);
        this.setState({ refreshingDevices: false });
      }, 3000);
    }
  };

  openEditModal = () => {
    const { selectedNetwork } = this.props;
    if (this.props.clearUpdateNetworkError) {
      this.props.clearUpdateNetworkError();
    }
    this.setState({
      showEditModal: true,
      editSsidName: selectedNetwork.wifiSsidName || '',
      editPassword: selectedNetwork.wifiSsidPassphrase || '',
      editBroadcast: selectedNetwork.broadcast !== undefined ? selectedNetwork.broadcast : true,
      showEditPassword: false,
      showConfirmPassword: false,
      showSsidGuidelines: false,
      showPasswordGuidelines: false,
      ssidError: '',
      passwordError: '',
    });
  };

  validateSsid = (value) => {
    if (!value || !value.trim()) return 'Please enter a Network Name (SSID).';
    if (value.length < 3) return 'Please keep the length between 3-32 characters.';
    if (/^[^a-zA-Z0-9]|[^a-zA-Z0-9]$/.test(value)) return "Please choose a name that doesn't start or end with a special character or space.";
    if (/[$<>`\\^&;"]/.test(value)) return "The following characters are not allowed $ < > ` \\ ^ & ; \"";
    return '';
  };

  validatePassword = (value) => {
    if (!value || !value.trim()) return 'Please enter a password.';
    if (value.length < 8) return 'Please keep the length between 8-29 characters.';
    if (/^[^a-zA-Z0-9]|[^a-zA-Z0-9]$/.test(value)) return "Please choose a password that doesn't start or end with a special character or space.";
    if (/[$<>`\\^&;"']/.test(value)) return "The following characters are not allowed $ < > ` \\ ^ & ; \" '";
    return '';
  };

  handleSsidChange = (e) => {
    const value = e.target.value;
    this.setState({ editSsidName: value, ssidError: this.validateSsid(value) });
  };

  handlePasswordChange = (e) => {
    const value = e.target.value;
    this.setState({ editPassword: value, passwordError: this.validatePassword(value) });
  };

  handleSave = () => {
    const ssidError = this.validateSsid(this.state.editSsidName);
    const passwordError = this.isPasswordEditable() ? this.validatePassword(this.state.editPassword) : '';
    if (ssidError || passwordError) {
      this.setState({ ssidError, passwordError });
      return;
    }
    if (this.props.clearUpdateNetworkError) {
      this.props.clearUpdateNetworkError();
    }
    this.setState({ showConfirmModal: true, showEditModal: false });
  };

  handleConfirm = () => {
    const { selectedNetwork } = this.props;
    const { editSsidName, editPassword, editBroadcast } = this.state;
    const payload = {
      wifiSsidName: editSsidName,
      broadcast: editBroadcast,
      enabled: selectedNetwork.enabled,
      wifiType: selectedNetwork.wifiType,
      masterAcct: selectedNetwork.bulkMasterAccount,
      configType: selectedNetwork.configType,
    };
    if (this.isPasswordEditable()) {
      payload.wifiSsidPassphrase = editPassword;
    }
    this.props.updateNetwork(payload);
  };

  handleRetry = () => {
    if (this.props.clearUpdateNetworkError) {
      this.props.clearUpdateNetworkError();
    }
    this.setState({ retrying: true, retryAttempted: true });
    setTimeout(() => {
      this.setState({ retrying: false });
      this.handleConfirm();
    }, 2000);
  };

  handleCancelEdit = () => {
    this.setState({ showEditModal: false, showConfirmModal: false, retrying: false, retryAttempted: false });
  };

  getFilteredDevices = () => {
    const { networkDevices } = this.props;
    const { connectionFilter } = this.state;
    if (!networkDevices || !networkDevices.length) return [];
    if (connectionFilter === 'All') return networkDevices;
    const stateMap = { CONNECTED: ['CONNECTED', 'ACTIVE'], DISCONNECTED: ['DISCONNECTED', 'OFFLINE'] };
    const allowed = stateMap[connectionFilter] || [connectionFilter];
    return networkDevices.filter((d) => {
      return d.connectionState && allowed.includes(d.connectionState.toUpperCase());
    });
  };

  isSignalMissing = (device) => {
    const s = device?.health?.status;
    return !s || s.trim() === '';
  };

  getSignalDot = (device) => {
    if (this.isSignalMissing(device)) return null;
    const status = device.health.status.toLowerCase();
    const color = status === 'offline' || status === 'poor' || status === 'fair' ? '#d6312b' : 'green';
    return <span className={classes.SignalDot} style={{ backgroundColor: color }} />;
  };

  getSignalLabel = (device) => {
    if (this.isSignalMissing(device)) {
      return <span>N/A</span>;
    }
    const status = device.health.status.charAt(0).toUpperCase() + device.health.status.slice(1).toLowerCase();
    const color = status === 'Poor' || status === 'Fair' || status === 'Offline' ? '#d6312b' : 'green';
    return <span style={{ color }}>{status}</span>;
  };

  getFreq = (device) => {
    if (!device.connectionState) return 'N/A';
    const conn = device.connectionState;
    if (conn.includes('6G')) return '6 GHz';
    if (conn.includes('5G')) return '5 GHz';
    if (conn.includes('2.4G') || conn.includes('2G')) return '2.4 GHz';
    if (conn.toLowerCase().includes('ethernet')) return 'Ethernet';
    return conn;
  };

  getConnectionStatus = (device) => {
    if (!device.connectionState) return 'N/A';
    const state = device.connectionState;
    return state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
  };

  renderPagination = (totalItems) => {
    const { currentPage } = this.state;
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE) || 1;

    const pages = [];
    for (let i = 1; i <= totalPages; i++) pages.push(i);

    const startItem = totalItems === 0 ? 0 : (currentPage - 1) * ITEMS_PER_PAGE + 1;
    const endItem = Math.min(currentPage * ITEMS_PER_PAGE, totalItems);

    return (
      <div className={classes.Pagination}>
        <button
          className={classes.PaginationBtn}
          disabled={currentPage === 1}
          onClick={() => this.setState({ currentPage: currentPage - 1 })}
          aria-label="previous page"
        >
          <MdKeyboardArrowLeft size={18} />
        </button>
        {pages.map((p) => (
          <button
            key={p}
            className={[classes.PaginationBtn, currentPage === p ? classes.PaginationBtnActive : ''].join(' ')}
            onClick={() => this.setState({ currentPage: p })}
          >
            {p}
          </button>
        ))}
        <button
          className={classes.PaginationBtn}
          disabled={currentPage === totalPages}
          onClick={() => this.setState({ currentPage: currentPage + 1 })}
          aria-label="next page"
        >
          <MdKeyboardArrowRight size={18} />
        </button>
        <span className={classes.PaginationInfo}>
          {startItem}-{endItem} of {totalItems} items
        </span>
      </div>
    );
  };

  render() {
    const { selectedNetwork, networkDevicesLoading, updateNetworkLoading } = this.props;
    const { showPassword, currentPage, connectionFilter, activeTab,
      showEditModal, showConfirmModal, editSsidName, editPassword,
      editBroadcast, showEditPassword, showConfirmPassword,
      showSsidGuidelines, showPasswordGuidelines, ssidError, passwordError } = this.state;

    if (!selectedNetwork) {
      // MDUNONBULK: No left panel networks, show Network Info directly
      if (this.isMduNonBulk() || this.isMduBulk()) {
        return (
          <div className={classes.NetworksPage}>
            <div className={classes.HeaderCard}>
              {(!this.isMduNonBulk() || this.props.isSpectrumReady) && (
                <h2 className={classes.NetworkName} style={{ marginBottom: 10 }}>Resident Network</h2>
              )}
              <div className={classes.TabsRow}>
                <button className={[classes.Tab, classes.TabActive].join(' ')}>
                  Network Info
                </button>
              </div>
            </div>
            <div className={classes.DevicesSection}>
              {this.props.tenantDetailsError ? (
                <div className={classes.ErrorCard}>
                  <div className={classes.ErrorIconRow}>
                    <FaExclamationCircle size={22} color="#d6312b" />
                    <span className={classes.ErrorTitle}>Error</span>
                  </div>
                  <p className={classes.ErrorMessage}>
                    UpStream service not available. Please refresh the page and try again. If error persists, please contact your supervisor.
                  </p>
                  <button className={classes.RefreshLink} onClick={() => this.props.getTenantData({})}>Refresh</button>
                </div>
              ) : this.props.tenantDetails && this.props.tenantDetails.content ? (
                <>
                  <div className={classes.IotStatsWrapper}>
                    <ResidentNetworks
                      getTenantData={this.props.getTenantData}
                      tenantStats={this.props.tenantStats}
                      filter={this.props.filter}
                      isLoading={this.props.tenantDetailsLoading}
                      tenantDetails={this.props.tenantDetails}
                    />
                  </div>
                  <div className={classes.IotTableWrapper}>
                    <PspView
                      tenantDetails={this.props.tenantDetails}
                      getTenantData={this.props.getTenantData}
                      onGetTenant={this.props.onGetTenant}
                      filter={this.props.filter}
                      isLoading={this.props.tenantDetailsLoading}
                      iotConfigured={this.props.iotConfigured}
                    />
                  </div>
                </>
              ) : (
                <Spinner />
              )}
            </div>
          </div>
        );
      }
      return (
        <div className={classes.EmptyState}>
          <p>Select a network from the left panel to view details.</p>
        </div>
      );
    }

    // Hide Home network from right panel
    if (selectedNetwork.wifiType === 'HOME' && !this.isMduBulk()) {
      return (
        <div className={classes.EmptyState}>
          <p>Select a network from the left panel to view details.</p>
        </div>
      );
    }

    const networkDevices = this.props.networkDevices || [];
    const filteredDevices = this.getFilteredDevices();
    const totalDevices = networkDevices.length;
    const connectedDevices = networkDevices.filter((d) => {
      const state = d.connectionState && d.connectionState.toUpperCase();
      return state === 'ACTIVE' || state === 'CONNECTED';
    }).length;
    const disconnectedDevices = networkDevices.filter((d) => {
      const state = d.connectionState && d.connectionState.toUpperCase();
      return state === 'OFFLINE' || state === 'DISCONNECTED';
    }).length;
    const pausedDevices = networkDevices.filter((d) => d.connectionState && d.connectionState.toUpperCase() === 'PAUSED').length;

    const indexOfLast = currentPage * ITEMS_PER_PAGE;
    const indexOfFirst = indexOfLast - ITEMS_PER_PAGE;
    const currentDevices = filteredDevices.slice(indexOfFirst, indexOfLast);

    const networkTypeLabel = NETWORK_TYPE_LABELS[selectedNetwork.wifiType] || selectedNetwork.wifiType;
    const password = selectedNetwork.wifiSsidPassphrase || '';
    const visibility = selectedNetwork.broadcast ? 'Visible' : 'Hidden';
    const availableTabs = this.getAvailableTabs(selectedNetwork.wifiType);
    const hasPassword = !!selectedNetwork.wifiSsidPassphrase;

    return (
      <div className={classes.NetworksPage}>

        {/* Header Card */}
        <div className={classes.HeaderCard}>
          <div className={classes.HeaderTop}>
            {(selectedNetwork.wifiType !== 'IOT' || this.props.isSpectrumReady) && (
              <div>
                <div className={classes.NetworkTypeLabel}>{networkTypeLabel}</div>
                <h2 className={classes.NetworkName}>{selectedNetwork.wifiSsidName}</h2>
              </div>
            )}
            {(selectedNetwork.wifiType !== 'IOT' || this.props.isSpectrumReady) && (
              <div className={classes.EditLinkWrapper}>
                <button
                  className={[classes.EditLink, !this.isCssoUser() ? classes.EditLinkDisabled : ''].join(' ')}
                  onClick={this.isCssoUser() ? this.openEditModal : undefined}
                  disabled={!this.isCssoUser()}
                >
                  <FaPencilAlt size={14} style={{ marginRight: 6 }} />
                  Edit WiFi Network Details
                </button>
                {!this.isCssoUser() && (
                  <div className={classes.EditTooltip}>
                    {selectedNetwork.wifiType === 'IOT' ? 'IoT' : selectedNetwork.wifiType.charAt(0).toUpperCase() + selectedNetwork.wifiType.slice(1).toLowerCase()} WiFi Network Details can only be edited by the CSSO team.
                  </div>
                )}
              </div>
            )}
          </div>
          {(selectedNetwork.wifiType !== 'IOT' || this.props.isSpectrumReady) && (
            <div className={classes.NetworkMeta}>
              {hasPassword && (
                <span className={classes.MetaItem}>
                  <span className={classes.MetaLabel}>Password: </span>
                  <span className={classes.PasswordDots}>
                    {showPassword ? password : '••••••••••'}
                  </span>
                  <button
                    className={classes.ShowPasswordBtn}
                    onClick={() => this.setState({ showPassword: !showPassword })}
                  >
                    {showPassword ? 'Hide Password' : 'Show Password'}
                  </button>
                </span>
              )}
              <span className={classes.MetaItem}>
                <span className={classes.MetaLabel}>Network Visibility: </span>
                <span>{visibility}</span>
              </span>
            </div>
          )}


          {/* Tabs */}
          {this.props.tenantDetails && !this.props.isSpectrumReady && !this.isMduNonBulk() && (
            <h2 className={classes.NetworkName} style={{ marginBottom: 10, marginTop: 10 }}>Resident Network</h2>
          )}
          <div className={classes.TabsRow}>
            {availableTabs.includes('NetworkInfo') && (
              <button
                className={[classes.Tab, activeTab === 'NetworkInfo' ? classes.TabActive : ''].join(' ')}
                onClick={() => this.setState({ activeTab: 'NetworkInfo' })}
              >
                Network Info
              </button>
            )}
            {availableTabs.includes('Devices') && (
              <button
                className={[classes.Tab, activeTab === 'Devices' ? classes.TabActive : ''].join(' ')}
                onClick={() => this.setState({ activeTab: 'Devices' })}
              >
                Devices
              </button>
            )}
          </div>
        </div>

        {/* Devices Section */}
        {activeTab === 'Devices' && (
          <div className={classes.DevicesSection}>

            {/* Refreshing spinner */}
            {(this.state.refreshingDevices || networkDevicesLoading) && <Spinner />}

            {/* No Devices Available. */}
            {!this.state.refreshingDevices && !networkDevicesLoading && networkDevices.length === 0 && (this.props.networkDevicesError || this.props.networkDevicesLoaded) && (
              <div className={classes.DeviceListCard}>
                <div className={classes.DeviceListHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h3 className={classes.DeviceListTitle}>Device List</h3>
                  <button className={classes.RefreshBtn} onClick={this.handleRefresh}>
                    <FaSync size={13} style={{ marginRight: 6 }} />
                    Refresh
                  </button>
                </div>
                <div className={classes.TableDivider} />
                <div className={classes.EmptyRow} style={{ padding: '24px', textAlign: 'center' }}>
                  {this.props.networkDevicesError && Number(this.props.networkDevicesError.status) >= 500
                    ? this.props.networkDevicesError.message || 'Internal server error'
                    : 'No devices available.'}
                </div>
              </div>
            )}

            {/* Stats Card */}
            {!this.state.refreshingDevices && !networkDevicesLoading && !this.props.networkDevicesError && networkDevices.length > 0 && (
            <div className={classes.StatsCard}>
              <div className={classes.StatsHeader}>
                <h3 className={classes.StatsTitle}>Devices</h3>
                <button className={classes.RefreshBtn} onClick={this.handleRefresh}>
                  <FaSync size={13} style={{ marginRight: 6 }} />
                  Refresh
                </button>
              </div>
              <div className={classes.StatsDivider} />
              <div className={classes.StatsRow}>
                <div className={classes.StatItem}>
                  <div className={classes.StatNumber}>{totalDevices}</div>
                  <div className={classes.StatLabel}>Total Devices</div>
                </div>
                <div className={classes.StatItem}>
                  <div className={classes.StatNumber}>{connectedDevices}</div>
                  <div className={classes.StatLabel}>Connected Devices</div>
                </div>
                <div className={classes.StatItem}>
                  <div className={classes.StatNumber}>{disconnectedDevices}</div>
                  <div className={classes.StatLabel}>Disconnected Devices</div>
                </div>
                <div className={classes.StatItem}>
                  <div className={classes.StatNumber}>{pausedDevices}</div>
                  <div className={classes.StatLabel}>Paused Devices</div>
                </div>
              </div>
            </div>

            )}

            {/* Device List Card */}
            {!this.state.refreshingDevices && !networkDevicesLoading && !this.props.networkDevicesError && networkDevices.length > 0 && (
            <div className={classes.DeviceListCard}>
              <div className={classes.DeviceListHeader}>
                <h3 className={classes.DeviceListTitle}>Device List</h3>
              </div>
              <div className={classes.TableDivider} />

              <>
                  <div className={classes.TableWrapper}>
                    <table className={classes.DeviceTable} cellPadding="0" cellSpacing="0">
                      <thead>
                        <tr>
                          <th className={classes.Th} style={{ width: '18%' }}>Device Name</th>
                          <th className={classes.Th} style={{ width: '14%' }}>Connected To</th>
                          <th className={classes.Th} style={{ width: '12%' }}>Signal</th>
                          <th className={classes.Th} style={{ width: '16%' }}>
                            <div>Connection</div>
                            <div style={{ marginTop: 4 }}>
                              <SelectDropdown
                                height={'30px'}
                                width={'120px'}
                                name="connectionFilter"
                                placeholder="All"
                                value={CONNECTION_FILTERS.filter((o) => o.value === connectionFilter)}
                                options={CONNECTION_FILTERS}
                                isSearchable={false}
                                onChange={(e) =>
                                  this.setState({ connectionFilter: e.value, currentPage: 1 })
                                }
                              />
                            </div>
                          </th>
                          <th className={classes.Th} style={{ width: '20%' }}>Device Model</th>
                          <th className={classes.Th} style={{ width: '20%' }}>Device MAC Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentDevices.length === 0 ? (
                          <tr>
                            <td colSpan="6" className={classes.EmptyRow}>
                              No devices available.
                            </td>
                          </tr>
                        ) : (
                          currentDevices.map((device, idx) => (
                            <tr key={device.deviceMacAddress || idx} className={classes.DeviceRow}>
                              <td className={classes.Td}>
                                {device.deviceName || 'Unknown Device'}
                              </td>
                              <td className={classes.Td}>{device.connectedTo || 'N/A'}</td>
                              <td className={classes.Td}>
                                {this.isSignalMissing(device)
                                  ? 'N/A'
                                  : <div className={classes.SignalCell}>
                                      {this.getSignalDot(device)}
                                      {this.getSignalLabel(device)}
                                    </div>
                                }
                              </td>
                              <td className={classes.Td}>
                                {device.connectionState
                                  ? (() => {
                                      const upper = device.connectionState.toUpperCase();
                                      const isConnected = upper === 'ACTIVE' || upper === 'CONNECTED';
                                      const color = isConnected ? 'green' : '#d6312b';
                                      const label = isConnected ? 'CONNECTED' : 'DISCONNECTED';
                                      return (
                                        <div className={classes.SignalCell}>
                                          <span className={classes.SignalDot} style={{ backgroundColor: color }} />
                                          <span style={{ color }}>{label}</span>
                                        </div>
                                      );
                                    })()
                                  : 'N/A'
                                }
                              </td>
                              <td className={classes.Td}>
                                {device.deviceType && device.deviceType.model ? device.deviceType.model : 'N/A'}
                              </td>
                              <td className={classes.Td}>{device.deviceMacAddress || 'N/A'}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  {this.renderPagination(filteredDevices.length)}
                </>
            </div>
            )}
          </div>
        )}

        {/* Network Info Section */}
        {activeTab === 'NetworkInfo' && selectedNetwork.wifiType === 'IOT' && (
          <div className={classes.DevicesSection}>
            {this.props.tenantDetailsError ? (
              <div className={classes.ErrorCard}>
                <div className={classes.ErrorIconRow}>
                  <FaExclamationCircle size={22} color="#d6312b" />
                  <span className={classes.ErrorTitle}>Error</span>
                </div>
                <p className={classes.ErrorMessage}>
                  UpStream service not available. Please refresh the page and try again. If error persists, please contact your supervisor.
                </p>
                <button className={classes.RefreshLink} onClick={() => this.props.getTenantData({})}>Refresh</button>
              </div>
            ) : this.props.tenantDetails && this.props.tenantDetails.content ? (
              <>
                <div className={classes.IotStatsWrapper}>
                  <ResidentNetworks
                    getTenantData={this.props.getTenantData}
                    tenantStats={this.props.tenantStats}
                    filter={this.props.filter}
                    isLoading={this.props.tenantDetailsLoading}
                    tenantDetails={this.props.tenantDetails}
                  />
                </div>
                <div className={classes.IotTableWrapper}>
                  <PspView
                    tenantDetails={this.props.tenantDetails}
                    getTenantData={this.props.getTenantData}
                    onGetTenant={this.props.onGetTenant}
                    filter={this.props.filter}
                    isLoading={this.props.tenantDetailsLoading}
                    iotConfigured={this.props.iotConfigured}
                  />
                </div>
              </>
            ) : (
              <Spinner />
            )}
          </div>
        )}


        {/* Edit WiFi Network Details Modal */}
        <Modal show={showEditModal} modalClosed={this.handleCancelEdit} deviceGroupConfirmation="true">
          <div className={classes.EditModalBody}>
            <h3 className={classes.EditModalTitle}>Edit WiFi Network Details</h3>

            {this.props.updateNetworkError && !this.state.retrying ? (
              <>
                <div className={classes.ApiErrorBox}>
                  <FaExclamationCircle size={20} color="#c0392b" style={{ flexShrink: 0 }} />
                  <div>
                    <p className={classes.ApiErrorText}>Unable to load WiFi Network Details. Please try again.</p>
                    <button className={classes.TryAgainBtn} onClick={this.handleRetry}>Try again</button>
                  </div>
                </div>
                <div className={classes.EditModalActions}>
                  <div style={{ flex: 1 }} />
                  <button className={classes.CancelBtn} style={{ flex: 'none', width: '160px' }} onClick={this.handleCancelEdit}>Cancel</button>
                </div>
              </>
            ) : this.state.retrying ? (
              <Spinner />
            ) : (
              <>
                {/* SSID Guidelines */}
            <div className={classes.GuidelinesDropdown}>
              <button
                className={classes.GuidelinesToggle}
                onClick={() => this.setState({ showSsidGuidelines: !this.state.showSsidGuidelines })}
              >
                <span>Guidelines</span>
                <span className={[classes.GuidelinesChevron, this.state.showSsidGuidelines ? classes.GuidelinesChevronOpen : ''].join(' ')}>&#8964;</span>
              </button>
              {this.state.showSsidGuidelines && (
                <div className={classes.GuidelinesContent}>
                  <ul className={classes.GuidelinesList}>
                    <li>Please keep the length between 3-32 characters.</li>
                    <li>Don't begin or end with a symbol or space.</li>
                    <li>The following characters are not allowed $ {'<'} {'>'} ` \ ^ &amp; ; "</li>
                  </ul>
                </div>
              )}
            </div>

            <div className={classes.EditField}>
              <label className={classes.EditLabel}>Network Name (SSID) *</label>
              <input
                className={[classes.EditInput, ssidError ? classes.EditInputError : ''].join(' ')}
                type="text"
                value={editSsidName}
                minLength={3}
                maxLength={32}
                onChange={this.handleSsidChange}
              />
              {ssidError && <span className={classes.FieldError}>{ssidError}</span>}
            </div>

            {/* Password Guidelines - only for non-GUEST networks */}
            {this.isPasswordEditable() && (
            <div className={classes.GuidelinesDropdown}>
              <button
                className={classes.GuidelinesToggle}
                onClick={() => this.setState({ showPasswordGuidelines: !this.state.showPasswordGuidelines })}
              >
                <span>Guidelines</span>
                <span className={[classes.GuidelinesChevron, this.state.showPasswordGuidelines ? classes.GuidelinesChevronOpen : ''].join(' ')}>&#8964;</span>
              </button>
              {this.state.showPasswordGuidelines && (
                <div className={classes.GuidelinesContent}>
                  <ul className={classes.GuidelinesList}>
                    <li>Please keep the length between 8-29 characters.</li>
                    <li>Don't begin or end with a symbol or space.</li>
                    <li>The following characters are not allowed $ {'<'} {'>'} ` \ ^ &amp; ; " '</li>
                  </ul>
                </div>
              )}
            </div>
            )}

            {this.isPasswordEditable() && (
            <div className={classes.EditField}>
              <label className={classes.EditLabel}>Password *</label>
              <div className={classes.PasswordInputWrapper}>
                <input
                  className={[classes.EditInput, passwordError ? classes.EditInputError : ''].join(' ')}
                  type={showEditPassword ? 'text' : 'password'}
                  value={editPassword}
                  minLength={8}
                  maxLength={29}
                  onChange={this.handlePasswordChange}
                />
                <button
                  className={classes.EyeBtn}
                  onClick={() => this.setState({ showEditPassword: !showEditPassword })}
                  aria-label="toggle password visibility"
                >
                  {showEditPassword ? <FaEyeSlash size={18} color="#0073d1" /> : <FaEye size={18} color="#0073d1" />}
                </button>
              </div>
              {passwordError && <span className={classes.FieldError}>{passwordError}</span>}
            </div>
            )}

            <div className={classes.EditField}>
              <div className={classes.VisibilityRow}>
                <span className={classes.EditLabel} style={{ marginBottom: 0 }}>Network Visibility</span>
                <span className={classes.VisibilityInfoWrapper}>
                  <FaExclamationCircle size={14} color="#0073d1" style={{ marginLeft: 6, cursor: 'pointer' }} />
                  <div className={classes.VisibilityTooltip}>This allows the network to be hidden or visible</div>
                </span>
              </div>
              <div style={{ marginTop: 8 }}>
                <Switch
                  checked={editBroadcast}
                  onChange={() => this.setState({ editBroadcast: !editBroadcast })}
                  onText="ON"
                  offText="OFF"
                />
              </div>
            </div>

            <div className={classes.EditModalActions}>
              <button className={classes.CancelBtn} onClick={this.handleCancelEdit}>Cancel</button>
              <button
                className={classes.SaveBtn}
                onClick={this.handleSave}
                disabled={
                  !editSsidName ||
                  !!ssidError ||
                  (this.isPasswordEditable() && (!editPassword || !!passwordError)) ||
                  (
                    editSsidName === (selectedNetwork.wifiSsidName || '') &&
                    editBroadcast === (selectedNetwork.broadcast !== undefined ? selectedNetwork.broadcast : true) &&
                    (!this.isPasswordEditable() || editPassword === (selectedNetwork.wifiSsidPassphrase || ''))
                  )
                }
              >
                Save Changes
              </button>
            </div>
            </>
            )}
          </div>
        </Modal>

        {/* Confirmation Modal */}
        <Modal show={showConfirmModal} modalClosed={() => this.setState({ showConfirmModal: false, showEditModal: true })} deviceGroupConfirmation="true">
          <div className={classes.ConfirmModalBody}>
            <div className={classes.ConfirmHeader}>
              <FaExclamationCircle size={22} color="#fff" style={{ marginRight: 10, flexShrink: 0 }} />
              <h3 className={classes.ConfirmTitle}>Change WiFi Network Details?</h3>
            </div>
            <div className={classes.ConfirmContent}>
              <p className={classes.ConfirmText}>
                Changing the WiFi Network Details will disconnect any devices that are currently connected.
                Devices can be reconnected with the new network details.
              </p>
              <p className={classes.ConfirmText}>Are you sure you want to change the WiFi Network Details?</p>

              <div className={classes.ConfirmField}>
                <div className={classes.ConfirmFieldLabel}>Network Name (SSID)</div>
                <div className={classes.ConfirmFieldValue}>{editSsidName}</div>
              </div>

              {this.isPasswordEditable() && (
              <div className={classes.ConfirmField}>
                <div className={classes.ConfirmFieldLabel}>Password</div>
                <div className={classes.ConfirmFieldValue}>
                  <span>{showConfirmPassword ? editPassword : '••••••••••'}</span>
                  <button
                    className={classes.ShowPasswordBtn}
                    onClick={() => this.setState({ showConfirmPassword: !showConfirmPassword })}
                  >
                    {showConfirmPassword ? 'Hide Password' : 'Show Password'}
                  </button>
                </div>
              </div>
              )}

              <div className={classes.ConfirmNote}>
                <strong>Note:</strong> Devices using MAC randomization will lose details for username, pause
                schedules, IP reservations, groups and port forwarding. Devices that use MAC randomization
                will have duplicate entries in the device list upon reconnecting the device.
              </div>

              <div className={classes.ConfirmActions}>
                <button className={classes.CancelBtn} onClick={() => this.setState({ showConfirmModal: false, showEditModal: true })}>Cancel</button>
                <button
                  className={classes.SaveBtn}
                  onClick={this.handleConfirm}
                  disabled={updateNetworkLoading}
                >
                  {updateNetworkLoading ? 'Saving...' : 'Confirm'}
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Success Modal */}
        <Modal show={this.state.showSuccessModal} modalClosed={() => this.setState({ showSuccessModal: false })}>
          <Success message="WiFi Network Details updated successfully!" />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedNetwork: state.propertyIOTNetwork.selectedNetwork,
  networkDevices: state.propertyIOTNetwork.networkDevices,
  networkDevicesLoading: state.propertyIOTNetwork.networkDevicesLoading,
  networkDevicesLoaded: state.propertyIOTNetwork.networkDevicesLoaded,
  networkDevicesError: state.propertyIOTNetwork.networkDevicesError,
  updateNetworkLoading: state.propertyIOTNetwork.updateNetworkLoading,
  updateNetworkSuccess: state.propertyIOTNetwork.updateNetworkSuccess,
  updateNetworkError: state.propertyIOTNetwork.updateNetworkError,
  deleteNetworkLoading: state.propertyIOTNetwork.deleteNetworkLoading,
  deleteNetworkSuccess: state.propertyIOTNetwork.deleteNetworkSuccess,
  deleteNetworkError: state.propertyIOTNetwork.deleteNetworkError,
  tenantDetails: state.propertyManager.tenantDetails,
  tenantStats: state.propertyManager.tenantStats,
  tenantDetailsLoading: state.propertyManager.tenantDetailsLoading,
  tenantDetailsError: state.propertyManager.tenantDetailsError,
  filter: state.propertyManager.filter,
  iotConfigured: state.propertyIOTNetwork.getIOTssidNetwork?.wifiSsidPassphrase,
  isSpectrumReady: state.propertyManager.tenantDetails?.isSpectrumReady === true,
  accountClassification: state.propertyManager.tenantDetails?.accountClassification,
});

const mapDispatchToProps = (dispatch) => ({
  getNetworkDevices: (wifiType) => dispatch(actions.getNetworkDevices(wifiType)),
  updateNetwork: (payload) => dispatch(actions.updateNetwork(payload)),
  clearUpdateNetworkError: () => dispatch(actions.clearUpdateNetworkError()),
  getNetworks: () => dispatch(actions.getNetworks()),
  getTenantData: (payload) => dispatch(actions.getPropertyManagerTenantDetails(
    payload?.connectionStatuses,
    payload?.search,
    payload?.page,
    payload?.size
  )),
  onGetTenant: (masterAcct, tenantAcct) => dispatch(actions.startAppSaga(masterAcct, tenantAcct)),
  setSelectedNetwork: (network) => dispatch(actions.setSelectedNetwork(network)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NetworksPage);
